var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import api from '@/shared/api';
import config from '@/config';
import handleHttpError from '@/shared/services/HandleHttpError';
import ToastrService from '@/shared/services/ToastrService';
import messages from '@/modules/documents/documentMessages';
import { SpinnerIcon } from '@/shared/components/Icons';
import OkCancelModal from '@/shared/components/OkCancelModal';
import { FormattedMessage } from 'react-intl';
import { SharepointFolderTree } from '@/modules/documents/modals/SharepointFolderTree';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import { SharepointFileSelector } from '@/modules/documents/modals/SharepointFileSelector';
var LinkFromSharepointModal = function (_a) {
    var show = _a.show, intl = _a.intl, onSave = _a.onSave, onClose = _a.onClose, relationId = _a.relationId, tags = _a.tags;
    var _b = useState([]), sites = _b[0], setSites = _b[1];
    var _c = useState(false), foldersLoading = _c[0], setFoldersLoading = _c[1];
    var _d = useState(true), sitesLoading = _d[0], setSitesLoading = _d[1];
    var _e = useState(null), selectedSiteId = _e[0], setSelectedSiteId = _e[1];
    var _f = useState(false), drivesLoading = _f[0], setDrivesLoading = _f[1];
    var _g = useState([]), drives = _g[0], setDrives = _g[1];
    var _h = useState(null), selectedDriveId = _h[0], setSelectedDriveId = _h[1];
    var _j = useState('/'), selectedFolderId = _j[0], setSelectedFolderId = _j[1];
    var _k = useState(null), selectedFileId = _k[0], setSelectedFileId = _k[1];
    var _l = useState(null), selectedFileName = _l[0], setSelectedFileName = _l[1];
    useEffect(function () {
        setSitesLoading(true);
        api.base
            .get("".concat(config.appUrls.documents, "/api/sharepoint/sites"))
            .then(function (x) {
            setSites(!x.data ? [] : x.data);
        }, function (error) {
            handleHttpError(intl)(error);
        })
            .finally(function () {
            setSitesLoading(false);
        });
    }, [intl]);
    useEffect(function () {
        setDrives([]);
        setSelectedFolderId('/');
        if (!selectedSiteId)
            return;
        setDrivesLoading(true);
        api.base
            .get("".concat(config.appUrls.documents, "/api/sharepoint/sites/").concat(selectedSiteId, "/drives"))
            .then(function (x) {
            setDrives(!x.data ? [] : x.data);
        }, function (error) {
            handleHttpError(intl)(error);
        })
            .finally(function () {
            setDrivesLoading(false);
        });
    }, [selectedSiteId, intl]);
    var save = function () {
        var url = "".concat(config.appUrls.documents, "/api/documents/LinkToAdminPulse?driveId=").concat(selectedDriveId, "&folderId=").concat(selectedFolderId, "&fileId=").concat(selectedFileId, "&filename=").concat(selectedFileName);
        if (tags) {
            url = "".concat(url, "&tags=").concat(tags);
        }
        if (relationId) {
            url = "".concat(url, "&relationId=").concat(relationId);
        }
        return api.base.post(url, {}).then(function (data) {
            ToastrService.changesSaved(intl);
            return onSave(data.data);
        }, function (error) {
            handleHttpError(intl)(error);
        });
    };
    var closeModal = function () {
        onClose();
    };
    if (!show)
        return null;
    var title = function () {
        if (!sitesLoading && !drivesLoading && !foldersLoading)
            return intl.formatMessage(messages.LinkFromSharepoint);
        return (_jsxs(_Fragment, { children: [intl.formatMessage(messages.LinkFromSharepoint), _jsx("span", __assign({ className: "margin5L" }, { children: _jsx(SpinnerIcon, {}) }))] }));
    };
    return (_jsx(OkCancelModal, __assign({ title: title(), show: show, onClose: closeModal, disabled: !selectedSiteId ||
            !selectedDriveId ||
            !selectedFolderId ||
            !selectedFileId ||
            !selectedFileName, onSave: save }, { children: _jsx("div", __assign({ className: "form-horizontal" }, { children: _jsx("div", { children: _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("label", __assign({ className: "control-label col-md-3" }, { children: _jsx(FormattedMessage, __assign({}, messages.SharepointSite)) })), _jsx("div", __assign({ className: "col-md-9", style: { marginTop: '7px' } }, { children: _jsxs("select", __assign({ disabled: sites.length < 1, onChange: function (e) { var _a; return setSelectedSiteId((_a = e.target) === null || _a === void 0 ? void 0 : _a.value); }, className: "form-control" }, { children: [_jsx("option", { value: null }), sites.map(function (site) { return (_jsx("option", __assign({ value: site.id }, { children: site.name }), site.id)); })] })) })), _jsx("label", __assign({ className: "control-label col-md-3" }, { children: _jsx(FormattedMessage, __assign({}, messages.SharepointDrive)) })), _jsx("div", __assign({ className: "col-md-9", style: { marginTop: '7px' } }, { children: _jsxs("select", __assign({ disabled: drives.length < 1, onChange: function (e) { var _a; return setSelectedDriveId((_a = e.target) === null || _a === void 0 ? void 0 : _a.value); }, className: "form-control" }, { children: [_jsx("option", { value: null }), drives.map(function (drive) { return (_jsx("option", __assign({ value: drive.id }, { children: drive.name }), drive.id)); })] })) })), _jsx("label", __assign({ className: "control-label col-md-3" }, { children: _jsx(FormattedMessage, __assign({}, messages.Folder)) })), _jsx("div", __assign({ className: "col-md-9", style: { marginTop: '7px' } }, { children: _jsx(SharepointFolderTree, { setLoading: setFoldersLoading, onSelectedFolderChanged: setSelectedFolderId, siteId: selectedSiteId, driveId: selectedDriveId }) })), _jsx("label", __assign({ className: "control-label col-md-3" }, { children: _jsx(FormattedMessage, __assign({}, messages.File)) })), _jsx("div", __assign({ className: "col-md-9", style: { marginTop: '7px' } }, { children: _jsx(SharepointFileSelector, { siteId: selectedSiteId, driveId: selectedDriveId, folderId: selectedFolderId, onFileSelected: function (name, fileId) {
                                    setSelectedFileName(name);
                                    setSelectedFileId(fileId);
                                }, selectedFileId: selectedFileId }) }))] })) }) })) })));
};
LinkFromSharepointModal.propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    relationId: PropTypes.string,
    tags: PropTypes.string,
};
LinkFromSharepointModal.defaultProps = {
    relationId: undefined,
    tags: undefined,
};
export default LinkFromSharepointModal;
